// @ts-nocheck

/**
 * * `1:1` - 1:1
 * `4:3` - 4:3
 * `16:9` - 16:9
 * `3:4` - 3:4
 * `9:16` - 9:16
 */
export type AspectRatioEnum =
  typeof AspectRatioEnum[keyof typeof AspectRatioEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AspectRatioEnum = {
  "1:1": "1:1",
  "4:3": "4:3",
  "16:9": "16:9",
  "3:4": "3:4",
  "9:16": "9:16",
} as const;
